type Properties = Record<string, string>;

export function css(node: HTMLElement | SVGElement, properties: Properties) {
    function setProperties() {
        for (const prop of Object.keys(properties)) {
            node.style.setProperty(`--${prop}`, properties[prop]);
        }
    }

    setProperties();

    return {
        update(newProperties: Properties) {
            properties = newProperties;
            setProperties();
        },
    };
}
